<template>
    <div>
        <div id="range" class="component">
            <div class="middle" @click="toggle">
                <span class="pill pill-light pill-back" style="padding: 6px 8px 6px 8px">
                    <i class="material-icons">notifications</i>
                </span>
                <span class="notification-count" v-if="unseenCount > 0">{{ unseenCount }}</span>
            </div>
        </div>
        <div v-if="visible" class="notifications-panel" @scroll="scrolling">
            <div class="panel-header">
                <div>
                    <h1>Notifications</h1>
                </div>
                <div>
                    <ui-icon-button
                        :disabled="!hasItems"
                        ref="button"
                        has-dropdown
                        icon="more_vert"
                        type="secondary"
                        style="vertical-align: middle;"
                        :loading="busy"
                        :append-dropdown-to-body="false"
                    >
                         <ui-menu
                            class="text-left"
                            contain-focus
                            has-icons
                            slot="dropdown"
                            @select="handleAction"
                            :options="actionOptions"
                            @close="$refs.button.closeDropdown()"
                        ></ui-menu>
                    </ui-icon-button>
                </div>
            </div>
            <div class="panel-body">
                <div class="loading-notifications" v-if="loading">
                    <div>
                        <ui-progress-circular :disable-transition="true" :size="32" v-if="loading" />
                    </div>
                </div>
                <div v-else-if="hasItems">
                    <notification v-for="item in items" :data="item" :key="item.id" />
                    <div v-if="loadingMore" style="padding: 2rem;">
                        <ui-progress-circular :disable-transition="true" :size="32" style="margin: auto;"  />
                    </div>
                </div>
                <div class="no-notifications" v-else >
                    No notifications
                </div>
            </div>
        </div>
        <transition name="slide" @after-leave="toastHidden">
            <div class="notification-toast" v-if="toast" >
                <notification is-toast :data="toast" @close="closeNotification(true)" />
            </div>
        </transition>
    </div>
</template>

<script>
    import Notification from "./elements/Notification";
    import { mapGetters } from 'vuex'

    const actionOptions = [
        { label: 'Mark all read', id: 'mark-all-read' },
        { label: 'Remove all', id: 'remove-all' }
    ]

    export default {
        components: { Notification },
        data() {
            return {
                loading: true,
                loadingMore: false,
                visible: false,
                toast: null,
                queue: [],
                busy: false,
                actionOptions
            }
        },
        mounted() {
            /*setTimeout(() => {
                this.showNotification({ data: { type: 'deal.stacked', }  })
                this.showNotification({ data: { type: 'deal.completed', }  })
            }, 5000)*/

            this.$store.dispatch('notifications/load', { page: 1 }).then(() => {
                this.loading = false
                this.$root.$on('notification', (notification) => {
                    this.showNotification(notification)
                    this.$store.commit('notifications/addItem', notification)
                })
            })

            document.addEventListener('click', (e) => {
                if (this.visible && !this.$el.contains(e.target)) {
                    this.visible = false
                }
            })
        },
        computed: {
            ...mapGetters({
                hasItems: 'notifications/hasItems',
                hasMore: 'notifications/hasMore',
                unseenCount: 'notifications/unseenCount'
            }),
            items() {
                return this.$store.state.notifications.items
            }
        },
        methods: {
            scrolling(e) {
                if (!this.loadingMore && this.hasMore && e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight < 1) {
                    this.loadingMore = true
                    this.$store.dispatch('notifications/load', { page: this.$store.state.notifications.meta.current_page + 1 }).finally(() => {
                        this.loadingMore = false
                    })
                }
            },
            handleAction(item) {
                console.log(item)
                let promise;

                switch (item.id)
                {
                    case 'mark-all-read':
                        promise = this.$store.dispatch('notifications/markAllRead')
                        break
                    case 'remove-all':
                        promise = this.$store.dispatch('notifications/destroyAll')
                        break
                }

                if (promise) {
                    this.busy = true
                    promise.catch(handleApiError)
                        .finally(() => { this.busy = false })
                }
            },
            toggle() {
                if (!this.visible) {
                    this.open()
                } else {
                    this.close();
                }
            },
            open() {
                this.visible = true
                this.closeNotification()
                if (this.unseenCount > 0) {
                    this.$store.dispatch('notifications/markAllSeen')
                }
            },
            close() {
                this.visible = false
            },
            showNotification(notification) {
                if (!this.visible) {

                    if (this.toast) {
                        this.queue.push(notification)
                        return;
                    }

                    this.toast = notification

                    setTimeout(() => {
                        this.closeNotification()
                    }, 10000)
                }
            },
            closeNotification(clearQueue = false) {
                if (clearQueue) {
                    this.queue = []
                }

                this.toast = null
            },
            toastHidden() {
                if (this.queue.length > 0) {
                    this.showNotification(this.queue.shift())
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .notification-toast {
        position: absolute;
        width: 400px;
        background: white;
        border-radius: 3px;
        top: 70px;
        color: #333;
        right: 15px;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, .1);
        overflow: hidden;
        transition: right .75s;

        &.slide-enter-active, &.slide-leave-active {
            right: 15px;
        }
        &.slide-enter, &.slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
            right: -400px;
        }
    }

    .no-notifications, .loading-notifications {
        padding: 1rem 0 3rem;
        text-align: center;
        overflow: hidden;
        line-height: 32px;

        & > div { max-height: 32px; overflow: hidden; }
        & > div > div { margin: auto; }
    }

    .notification-count {
        background: #bc0101;
        font-size: 9px;
        display: inline-block;
        padding: 0px 4px;
        border-radius: 3px;
        color: #fff;
        position: absolute;
        right: -4px;
        top: -4px;
        opacity: 1 !important;
    }

    .notifications-panel {
        background: white;
        padding: 0;
        box-shadow: 0 0 5px 5px rgba(0, 0, 0, .1);
        border-radius: 5px;
        top: 70px;
        position: absolute;
        right: 15px;
        width: 370px;
        max-height: calc(100vh - 90px);
        color: #42526e;
        overflow-y: auto;
        overflow-x: hidden;

        .panel-header {
            display: flex;
            align-items: center;
            padding: 0 1.5rem;
            height: 55px;

            div:first-of-type {
                h1 { font-size: 20px; font-weight: 600; margin-bottom: 0; }
                flex: 1;
            }

            div:last-of-type {
                text-align: right;
                flex: 1;
            }
        }
    }
</style>